// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3sTGX","header":"ReportDetails_header__38cPr","title":"ReportDetails_title__1yTAw","left":"ReportDetails_left__1fCDD"};